export { default } from "./useAdminConsoleAddSchool";
